class ErrorHandler {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  static handleError(error: any) {
    if (error.message === "UserInfo is null") {
      console.error(error);
      // router.push({ name: "login" });
    } else {
      console.error(error);
    }
  }
}

export default ErrorHandler;
